<template>
  <div class="bh-benefits">
    <section>
      <router-view />
    </section>
  </div>
</template>

<script lang="ts">
export default {
  name: 'BhBenefits',
};
</script>
